<template>
    <div :class="[
        'z-wide-section',
        { 'z-wide-section--centered': centered }
    ]">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'z-wide-section',
    props: {
        centered: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
